var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { deprecated } from 'core-decorators';
import { Core, JsonLd } from '../../Constants';
export function Mixin(Base) {
    class ApiDocumentation extends Base {
        get classes() {
            return this.getArray(Core.Vocab('supportedClass'));
        }
        getOperations(classUri, predicateUri) {
            const clas = this.getClass(classUri);
            if (!clas) {
                return [];
            }
            if (!predicateUri) {
                return clas.supportedOperations;
            }
            const supportedProperty = clas.supportedProperties.find((prop) => {
                return prop.property && prop.property.id === predicateUri;
            });
            if (!supportedProperty) {
                return [];
            }
            return supportedProperty.property.supportedOperations;
        }
        getProperties(classUri) {
            const clas = this.getClass(classUri);
            if (!clas) {
                return [];
            }
            return clas.supportedProperties;
        }
        getClass(classId) {
            return this.classes.find((clas) => clas[JsonLd.Id] === classId) || null;
        }
        getEntrypoint() {
            return this.loadEntrypoint();
        }
        loadEntrypoint() {
            const entrypoint = this.get(Core.Vocab('entrypoint'));
            if (!entrypoint) {
                return Promise.reject(new Error('The ApiDocumentation doesn\'t have an entrypoint.'));
            }
            return this._alcaeus.loadResource(entrypoint.id);
        }
    }
    __decorate([
        deprecated,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ApiDocumentation.prototype, "getEntrypoint", null);
    return ApiDocumentation;
}
export const shouldApply = (res) => res.types.contains(Core.Vocab('ApiDocumentation'));
//# sourceMappingURL=ApiDocumentation.js.map